import styled from "@emotion/styled";
import { Button, ButtonProps } from "@ui/components/buttons/button";
import { colors } from "@ui/style/colors";
import React from "react";

export const RoundedButton = (props: ButtonProps): JSX.Element => <StyledButton {...props} />;

const StyledButton = styled(Button)`
	border-radius: 100px;
	padding: 20px 35px;
	background-color: ${colors.mobilePrimaryBlue};
	width: 100%;

	:hover {
		background-color: ${colors.mobileDarkPrimaryBlue} !important;
	}

	span {
		font-family: "HeadingNow";
		font-size: 16px;
		font-weight: 400 !important;
	}
`;
